module.exports = __webpack_public_path__ + "img/19.59728d10.png";